export const LANG = {
    SC: 'zh-cn',
    TC: 'zh-hk',
    EN: 'en-us',
    JA: 'ja',
    // FR: 'fr'
};

export const LANG_OPTIONS = [
    { label: '简体', value: LANG.SC },
    { label: '繁体', value: LANG.TC },
    { label: '英文', value: LANG.EN },
    { label: '日语', value: LANG.JA },
    // { label: '法语', value: LANG.FR },
];

export const AREA = {
    US: 'us',
};

// https://gitlab.futunn.com/nodepackage/lang
export const LANG_NUM_MAP = {
    [LANG.SC]: 0,
    [LANG.TC]: 1,
    [LANG.EN]: 2,
    [LANG.JA]: 5,
    // [LANG.FR]: 7,
};

export default {
    [AREA.US]: {
        [LANG.SC]: {
            empty: '暂无数据',
            btn: '查看',
            detailBtn: '查看详情',
        },
        [LANG.TC]: {
            empty: '暫無數據',
            btn: '審查',
            detailBtn: '查看詳情',
        },
        [LANG.EN]: {
            empty: 'No data.',
            btn: 'View',
            detailBtn: 'Details',
        },
        [LANG.JA]: {
            empty: 'データなし',
            btn: 'チェック',
            detailBtn: '詳細',
        },
        // [LANG.FR]: {
        //     empty: 'No data.',
        //     btn: 'View',
        //     detailBtn: 'Details',
        // },
    }
};
